/**
 * Task module constants and configuration
 */

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api/v2`;

// Status config with Norwegian labels
export const STATUS_CONFIG = {
  not_started: { 
    label: 'Ikke startet', 
    color: 'bg-gray-100 text-gray-700',
    bgColor: 'bg-gray-50',
    icon: '○'
  },
  in_progress: { 
    label: 'Under arbeid', 
    color: 'bg-blue-100 text-blue-700',
    bgColor: 'bg-blue-50',
    icon: '◐'
  },
  completed: { 
    label: 'Ferdig', 
    color: 'bg-green-100 text-green-700',
    bgColor: 'bg-green-50',
    icon: '●'
  }
};
